<script lang="ts">
    import {authFetch} from '../Auth'
    import {getRouteById} from "../Nav";
    import type {ChatData, UserData} from '../Types'
    import throttle from "@jcoreio/async-throttle";
    import {DateTime} from "luxon";
    import AuthImage from "../Component/AuthImage.svelte";
    import ChatMessages from "../Component/ChatMessages.svelte";
    import UserChatRow from "../Component/UserChatRow.svelte";
    export let params: {
        userId: string,
        chat_id: string,
    }

    let filter = {
        user_id: null,
        offset: 0,
        limit: 100,
        phrase: "",
        include_channel: true,
    }
    let listPromise: Promise<ChatData>
    let list: ChatData[] = []
    let count: number = 0
    let user: UserData
    let chat_id: string = null

    $: {
        filter.user_id = params.userId
        if (params.chat_id !== undefined) {
            chat_id = params.chat_id
        }
        update()
    }

    async function loadList() {
        let response = await authFetch('/user/chats', {
            method: 'POST',
            body: JSON.stringify(filter)
        })
        if (response.ok) {
            let data = await response.json()
            list = data.list
            if (chat_id === null && list.length > 0) {
                chat_id = list[0].id
            }
            count = data.count
            user = data.user
        } else {
            alert(response.statusText)
        }
    }

    let onInput = throttle(() => {
        update()
    }, 1000)

    function update() {
        listPromise = loadList()
    }

    let printMode: boolean = false

</script>
<style lang="scss">
    .box{
      position: fixed; bottom: 0px; left: 0px; right: 0px; display: flex; top: 56px; flex: 1 1 auto; flex-direction: row;
    .left {flex: 0 0 700px; overflow: auto}
    .right {flex: 0 1 auto; overflow: auto; flex-grow: 1}
    }
    .printMode {
        &.box{
          margin-top: -56px;
          position: static;
          .left {display: none}
          .right {flex: 1 1 auto;}
        }
    }
</style>
<div class="box" class:printMode={printMode}>
    <div class="left">
        <table class="table table-bordered table-sm table-hover">
            <thead class="position-sticky bg-white shadow" style="top: 0px; z-index: 1030;">
            <tr style="border: 0px;">
                <th colspan="100" class="p-1">
                    {#await listPromise}
                        {""}
                    {:then _}
                        <div class="btn-group mb-1">
                            <div class="btn btn-sm btn-outline-secondary" style="cursor:auto;">Ціль:</div>
                            <a class="btn btn-sm btn-secondary"
                                    href="#{getRouteById('User').hash(user.id)}"
                                    title="{user.username ?? ''} {user.names.map((item)=>item.name).join()}"
                            >{user.username ?? ''} {user.names.map((item)=>item.name).join()}</a>
                        </div>
                    {/await}
                    <div class="input-group">
                        <input class="form-control" type="search" placeholder="Назва чату"
                               bind:value={filter.phrase} on:keyup={onInput} on:change={onInput}>
                        <label class="btn btn-primary">
                            <input type="checkbox" class="form-check-input" autocomplete="off"
                                   bind:checked={filter.include_channel} on:change={update}>
                            &nbsp;Канали
                        </label>
<!--                        <button class="btn btn-info"-->
<!--                                class:disabled={filter.offset===0}-->
<!--                                on:click={()=>{filter.offset-=filter.limit;update()}}>-->
<!--                            <i class="bi bi-chevron-left"></i>-->
<!--                        </button>-->
<!--                        <input class="form-control flex-grow-0" type="number" style="width: 5em;"-->
<!--                               min="1"-->
<!--                               max={Math.floor(count / filter.limit)+1}-->
<!--                               step="1"-->
<!--                               value={(filter.offset / filter.limit)+1}-->
<!--                               on:change={(ev)=>{filter.offset=(ev.target.value - 1) * filter.limit; update()}}-->
<!--                        >-->
<!--                        <button class="btn btn-info disabled">-->
<!--                            / {Math.floor(count / filter.limit)+1}-->
<!--                        </button>-->
<!--                        <button class="btn btn-info"-->
<!--                                class:disabled={list.length < filter.limit}-->
<!--                                on:click={()=>{filter.offset+=filter.limit;update()}}>-->
<!--                            <i class="bi bi-chevron-right"></i>-->
<!--                        </button>-->
                    </div>
                </th>
            </tr>
            <tr style="border: 0px; font-size: 14px;" class="text-nowrap">
                <th>ID</th>
                <th></th>
                <th>Тип</th>
                <th style:width="100%">Назва</th>
                <th>Канал?</th>
                <th style="min-width: 140px;" colspan="2">Повідомлення</th>
                <th colspan="2"></th>
            </tr>
            </thead>
            <tbody>
            {#await listPromise}
                <tr>
                    <td colspan="1000" class="text-center">
                        <div class="spinner-grow"></div>
                    </td>
                </tr>
            {:then _}
                {#if list.length > 0}
                    {#each list as chat}
                        <UserChatRow {user} {chat} chat_id={chat_id}/>
                    {/each}
                {:else}
                    <tr>
                        <td colSpan="1000" class="text-center">
                            <div class="alert alert-secondary">Немає чатів</div>
                        </td>
                    </tr>
                {/if}
            {:catch error}
                <tr>
                    <td colSpan="1000" class="text-center">
                        <div class="alert alert-danger">{error}</div>
                    </td>
                </tr>
            {/await}
            </tbody>
        </table>
    </div>
    <div class="right">
        {#await listPromise}
            {""}
        {:then _}
            {#if chat_id !== null}
                <ChatMessages {user} {chat_id} on:printMode={()=>printMode=!printMode}/>
            {/if}
        {/await}
    </div>
</div>
